import ui1 from "../../assets/ui/ui1.png";
import ui2 from "../../assets/ui/ui2.png";
import ui3 from "../../assets/ui/ui3.png";
import './styles/gallery.footer.css';

export default function FooterUI() {
  const phoneNumber = '010-7485-7337';

  return (
    <div className="footer-ui">
      {/* 전화 */}
      <a href={`tel:${phoneNumber}`}>
        <img src={ui1} alt="전화" />
      </a>

      {/* 번호 표시 */}
      <button
        className="ui-btn"
        onClick={() => alert(phoneNumber)}
      >
        <img src={ui2} alt="번호 보기" />
      </button>

      {/* 블로그 */}
      <a
        href="https://blog.naver.com/hongiu"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={ui3} alt="블로그" />
      </a>
    </div>
  );
}